import { render, staticRenderFns } from "./crowd-Dialog.vue?vue&type=template&id=d2a24400&scoped=true"
import script from "./crowd-Dialog.vue?vue&type=script&lang=js"
export * from "./crowd-Dialog.vue?vue&type=script&lang=js"
import style0 from "./crowd-Dialog.vue?vue&type=style&index=0&id=d2a24400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a24400",
  null
  
)

export default component.exports